import React, { useRef, useState, useEffect } from 'react';
import T from 'prop-types';

import { ScrollableWrapperS } from './scrollable-wrapperS';

export const RefScrollableWrapper = React.createContext();

export const ScrollableWrapper = ({
  children,
  heightParameter,
  wrapper: Component,
  ...rest
}) => {
  const [contextValue, setContextValue] = useState();
  const targetRef = useRef();

  useEffect(() => {
    if (targetRef.current) setContextValue(targetRef.current);
  }, [targetRef]);

  return (
    <Component
      innerRef={targetRef}
      heightParameter={heightParameter}
      {...rest}
    >
      <RefScrollableWrapper.Provider value={contextValue}>
        {children}
      </RefScrollableWrapper.Provider>
    </Component>
  );
};

ScrollableWrapper.propTypes = {
  children: T.oneOfType([T.arrayOf(T.node), T.node]).isRequired,
  heightParameter: T.string,
  wrapper: T.oneOfType([T.arrayOf(T.node), T.node, T.func]),
};

ScrollableWrapper.defaultProps = {
  heightParameter: '180px',
  wrapper: ScrollableWrapperS,
};



// WEBPACK FOOTER //
// ./src/components/ui-helpers/scrollable-wrapper/index.js